import XIcon from "assets/icon/XIcon"

export default function BackButton(props){
    return(
        <button className="button flex gap-2 items-center" onClick={props?.onClick}>
            <XIcon className="w-4 fill-white" />
            <span className="text-sm">Back</span>
        </button>
    )
}